<template>
  <div class="position-relative">
    <div class="mt-2 ml-2 mr-2 position-absolute" v-if="deletable" style="z-index: 1;">
      <ci-awesome-icon icon="times" button @click="onDeleteClick" />
    </div>
    <div>
      <img :src="`${image.file_url}`" ref="image" @dragstart="$event.preventDefault()" style="max-width: 100%;">
    </div>
  </div>
</template>

<script>
import { FocusPicker } from 'image-focus';
import AwesomeIcon from '@/components/AwesomeIcon.vue';

export default {
  name: 'ElementImageFocal',

  components: {
    'ci-awesome-icon': AwesomeIcon,
  },

  props: {
    deletable: {
      type: Boolean,
      default: false,
      required: false,
    },

    image: {
      type: Object,
      required: true,
    },

    focalPoint: {
      type: Object,
      required: false,
      default() {
        return {
          x: 0,
          y: 0,
        };
      },
    },
  },

  watch: {
    focalPoint(newVal) {
      this.getFocalPointfocusPicker.focus = newVal;
      this.getFocalPointfocusPicker.updateRetinaPositionFromFocus();
    },
  },

  mounted() {
    let startingFocus = {
      x: 0,
      y: 0,
    };

    if (this.focalPoint && this.focalPoint.x && this.focalPoint.y) {
      startingFocus = this.focalPoint;
    }

    this.getFocalPointfocusPicker = new FocusPicker(this.$refs.image, {
      onChange: (focus) => {
        this.$emit('image:set-focalpoint', focus);
      },
      focus: startingFocus,
    });
  },

  methods: {
    onDeleteClick() {
      this.$emit('image:delete', this.image);
    },
  },
};
</script>
